import { memo, useMemo } from "react";
import "./pagination.css";
// import { Button } from "@components/button";
// import { DOTS, usePagination } from "@hooks/usePagination";
import { GrFormPrevious, GrFormNext } from "react-icons/gr";
import { BsThreeDots } from "react-icons/bs";
import { PaginationLoader } from "./loader";
// import usePagination from "@mui/material/usePagination/usePagination";
import { Button } from "@mui/material";
import { DOTS, usePagination } from "../../hooks/usePagination";

const PaginationComponent = ({
  totalRecords,
  paginationLoading,
  totalPages,
  currentPage,
  onNextPage,
  onPrevPage,
  onPageChange,
  pageSize,
}) => {
  const { showPrevButton, showNextButton } = useMemo(() => {
    return {
      showPrevButton: currentPage > 1,
      showNextButton: currentPage < totalPages,
    };
  }, [currentPage, totalPages]);
  const paginationRange = usePagination({
    currentPage,
    totalRecords,
    pageSize,
  });

  if (paginationLoading) {
    return <PaginationLoader />;
  }

  return (
    <>
      {totalPages > 1 ? (
        <div className="pagination">
          <span className="page-count">Total Records: {totalRecords}</span>
          {paginationRange && paginationRange?.length > 1 ? (
            <div className="paging-block">
              <span className="page-count">Page:</span>
              {showPrevButton && (
                <Button onClick={onPrevPage}>
                  <GrFormPrevious color="black" />
                </Button>
              )}

              {paginationRange?.map((pageNumber, index) => {
                if (pageNumber === DOTS) {
                  return (
                    <Button disabled={true} key={index}>
                      &#8230;
                    </Button>
                  );
                }

                return (
                  <Button
                    className={pageNumber === currentPage ? "active" : ""}
                    onClick={() => onPageChange(pageNumber)}
                    key={index}
                    sx={{
                      width: "100px",
                      backgroundColor: "#e8442d",
                      fontFamily: "Bai Jamjuree",
                      color: "white",
                      fontWeight: "900",
                      "&:hover": {
                        backgroundColor: "#e85d01",
                        color: "white",
                      },
                      "&:active": {
                        backgroundColor: "#e85d01",
                      },
                    }}
                  >
                    {pageNumber}
                  </Button>
                );
              })}

              {showNextButton && (
                <Button onClick={onNextPage}>
                  <GrFormNext color="black" />
                </Button>
              )}
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export const Pagination = memo(PaginationComponent);
